import { EMPTY_MASTER_COUNTER_CUSTOMER_CHARGEANY_MODEL } from "presentation/model/CounterCustomerCharge/CounterCustomerChargeMaintenanceModel";
import { useState } from "react";
import { createContainer } from "react-tracked";

const {
    Provider: CounterCustomerChargeMaintenanceProvider,
    useTracked: useCounterCustomerChargeMaintenanceTracked
} = createContainer(() => useState(EMPTY_MASTER_COUNTER_CUSTOMER_CHARGEANY_MODEL), {concurrentMode: true});
export { CounterCustomerChargeMaintenanceProvider, useCounterCustomerChargeMaintenanceTracked };

